import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './ImportantLinks.css';

const links = [
  {
    name: 'Income Tax',
    logo: 'https://i.postimg.cc/8cvJVyCk/image.png',
    url: 'https://www.incometax.gov.in/'
  },
  {
    name: 'GST',
    logo: 'https://i.postimg.cc/zBsvpnFs/image.png',
    url: 'https://www.gst.gov.in/'
  },
  {
    name: 'MCA',
    logo: 'https://i.postimg.cc/9M5Hn1sY/image.png',
    url: 'https://www.mca.gov.in/'
  },
  {
    name: 'RBI',
    logo: 'https://i.postimg.cc/tJ9QXJq1/image.png',
    url: 'https://www.rbi.org.in/'
  },
  {
    name: 'SEBI',
    logo: 'https://i.postimg.cc/DZ2B0XGK/image.png',
    url: 'https://www.sebi.gov.in/'
  },
    {
    name: 'e-Courts',
    logo: 'https://i.postimg.cc/cCzmFkbs/image.png',
    url: 'https://ecourts.gov.in/'
  }
];

const ImportantLinks: React.FC = () => {
  return (
    <Container className="py-5">
      <h2 className="text-center mb-4">Important Links</h2>
      <Row>
        {links.map(link => (
          <Col key={link.name} xs={6} md={4} lg={2} className="text-center mb-4">
            <a href={link.url} target="_blank" rel="noopener noreferrer" className="link-card">
              <Card>
                <Card.Img variant="top" src={link.logo} className="p-3" />
                <Card.Body>
                  <Card.Title>{link.name}</Card.Title>
                </Card.Body>
              </Card>
            </a>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ImportantLinks;
